// Must match the keys `just art-sync` uploads (scripts/art-sync.ts), so art lookups need no name→slug map.
export function slugify(name: string): string {
  return name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
}

// Where a card's image is served.
export function artUrl(name: string): string {
  return `/art/${slugify(name)}.jpg`;
}
